"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Page = _interopRequireDefault(require("@/ui/layout/Page"));
var _vuex = require("vuex");
var _validators = require("vuelidate/lib/validators");
var _constants = require("@/config/constants");
var _components = require("@/ui/components");
var _utils = require("@/utils");
var _vueTheMask = require("vue-the-mask");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validCNPJCPF = function validCNPJCPF(value) {
  return (0, _utils.validateCNPJorCPF)(value);
};
var dataForm = {
  name: '',
  address: '',
  city: '',
  state: '',
  phone: '',
  cnpj: '',
  stateRegistration: '',
  technicalManager: '',
  technicalIdentification: '',
  ownerId: '',
  initials: '',
  lat: '',
  lng: '',
  about: '',
  images: []
};
var _default = exports.default = {
  name: 'FarmData',
  components: {
    Page: _Page.default,
    TheMask: _vueTheMask.TheMask,
    MapMakerCard: _components.MapMakerCard,
    AppInput: _components.AppInput
  },
  data: function data() {
    return {
      updateCenterMap: null,
      errors: [],
      edited: false,
      message: 'Preencha o formulário corretamente',
      form: dataForm,
      dataFarm: {},
      dataUsers: [],
      selected: null,
      isFetching: false,
      ownerName: null,
      owner: {},
      states: _constants.LIST_STATES,
      center: {
        lat: -15.800639736833038,
        lng: -47.86137374761963
      },
      position: {
        lat: -15.800639736833038,
        lng: -47.86137374761963
      },
      loadingImage: false,
      imageUpload: null
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)({
    menuItemsFarm: 'menuItemsFarm',
    allPlots: 'allPlots',
    isLoading: 'isLoading'
  })),
  watch: {
    form: {
      handler: function handler(val) {
        this.edited = true;
      },
      deep: true
    },
    imageUpload: function () {
      var _imageUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var _this = this;
        var reader;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (val) {
                reader = new FileReader();
                reader.readAsDataURL(val);
                reader.onloadend = function () {
                  _this.form.images.push(reader.result);
                };
              }
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function imageUpload(_x) {
        return _imageUpload.apply(this, arguments);
      }
      return imageUpload;
    }()
  },
  validations: {
    form: {
      name: {
        required: _validators.required,
        min: (0, _validators.minLength)(10)
      },
      address: {
        required: _validators.required,
        min: (0, _validators.minLength)(10)
      },
      city: {
        required: _validators.required
      },
      state: {
        required: _validators.required,
        min: (0, _validators.minLength)(2)
      },
      phone: {
        required: _validators.required,
        min: (0, _validators.minLength)(10)
      },
      cnpj: {
        required: _validators.required,
        min: (0, _validators.minLength)(11),
        validCNPJCPF: validCNPJCPF
      },
      stateRegistration: {
        max: (0, _validators.maxLength)(25)
      },
      technicalManager: {
        required: _validators.required
      },
      technicalIdentification: {
        required: _validators.required
      },
      initials: {
        required: _validators.required
      },
      lat: {
        required: _validators.required
      },
      lng: {
        required: _validators.required
      },
      about: {
        required: _validators.required
      },
      images: {}
    }
  },
  mounted: function mounted() {
    this.getDataFarmRest();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchFarms', 'updateDataFarm', 'getUsersRest', 'setLoading'])), {}, {
    updateCoordinates: function updateCoordinates(location) {
      this.position = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng()
      };
    },
    scrollToTop: function scrollToTop() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    showToast: function showToast(type, msg) {
      this.scrollToTop();
      this.$buefy.notification.open({
        duration: 5000,
        message: msg || this.message,
        position: 'is-bottom-right',
        type: type || 'is-danger',
        hasIcon: true
      });
    },
    getAsyncData: function () {
      var _getAsyncData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(name) {
        var _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (name.length) {
                _context2.n = 1;
                break;
              }
              this.dataUsers = [];
              return _context2.a(2);
            case 1:
              this.isFetching = true;
              _context2.p = 2;
              _context2.n = 3;
              return this.getUsersRest({
                name: name
              });
            case 3:
              this.dataUsers = _context2.v;
              this.isFetching = false;
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              this.dataUsers = [];
              this.isFetching = false;
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4]]);
      }));
      function getAsyncData(_x2) {
        return _getAsyncData.apply(this, arguments);
      }
      return getAsyncData;
    }(),
    updateDataFarmRest: function () {
      var _updateDataFarmRest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.setLoading(true);
              _context3.p = 1;
              _context3.n = 2;
              return this.updateDataFarm(this.form);
            case 2:
              this.showToast('is-success', 'Dados atualizados com sucesso');
              this.cancel();
              this.setLoading(false);
              this.getDataFarmRest();
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              this.showToast('is-danger', 'Falha ao atualizar os dados');
              this.setLoading(false);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function updateDataFarmRest() {
        return _updateDataFarmRest.apply(this, arguments);
      }
      return updateDataFarmRest;
    }(),
    getDataFarmRest: function () {
      var _getDataFarmRest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.setLoading(true);
              _context4.p = 1;
              _context4.n = 2;
              return this.fetchFarms({
                type: 'current'
              });
            case 2:
              this.dataFarm = _context4.v;
              this.setFormData();
              this.setLoading(false);
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              this.setLoading(false);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3]]);
      }));
      function getDataFarmRest() {
        return _getDataFarmRest.apply(this, arguments);
      }
      return getDataFarmRest;
    }(),
    submitFormFarm: function submitFormFarm() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        this.showToast();
        return;
      }
      this.updateDataFarmRest();
    },
    cancel: function cancel() {
      this.$v.form.$reset();
    },
    resertFormData: function () {
      var _resertFormData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this2 = this;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return Object.keys(this.form).forEach(function (key) {
                if (typeof _this2.form[key] === 'string') _this2.form[key] = '';
              });
            case 1:
              this.edited = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function resertFormData() {
        return _resertFormData.apply(this, arguments);
      }
      return resertFormData;
    }(),
    setFormData: function () {
      var _setFormData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _this3 = this;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return Object.keys(this.dataFarm).forEach(function (key) {
                if (_this3.form.hasOwnProperty(key)) _this3.form[key] = _lodash.default.cloneDeep(_this3.dataFarm[key]);
              });
            case 1:
              if (!this.form['images']) {
                this.form.images = [];
              }
              if (!this.form.cnpj) {
                this.form.cnpj = '';
              }
              this.form.ownerId = _lodash.default.cloneDeep(this.dataFarm.owner.id);
              this.form.id = _lodash.default.cloneDeep(this.dataFarm.id);
              this.owner = _lodash.default.cloneDeep(this.dataFarm.owner);
              this.updateCenterMap = Math.random();
            case 2:
              return _context6.a(2);
          }
        }, _callee6, this);
      }));
      function setFormData() {
        return _setFormData.apply(this, arguments);
      }
      return setFormData;
    }(),
    deleteImage: function deleteImage(img) {
      var imgs = this.form.images.filter(function (item) {
        return item !== img;
      });
      this.form.images = imgs;
    }
  })
};